import React, { forwardRef } from "react";
import "./Navbar.css";

const Navbar = ({ handleToggleHamburger, isActive, className, style }, ref) => {
  return (
    <div className={"flex " + className} style={style}>
      <div className="flex-1">
        <a href="https://university.taylors.edu.my/en.html" target="_blank" rel="noreferrer">
          <img
            src={require("../../Assets/logo.png")}
            className="object-cover logo"
            alt="Logo"
          />
        </a>
      </div>
      <div className="flex-1">
        <div className="text-align-middle">
          <div
            className={isActive ? "hamburger is-active" : "hamburger"}
            id="hamburger-6"
            ref={ref}
            onClick={handleToggleHamburger}
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Navbar);
